import { relations } from 'drizzle-orm'
import { index, pgTable, text, unique } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getId,
  getIdReference,
} from '../common/utils'
import { opportunities } from './opportunity'

export const tags = pgTable(
  'tags',
  {
    ...getBaseFields(),
    name: text().notNull(),
    color: text().notNull().default('gray'),
    description: text(),
  },
  (table) => [
    ...getBaseIndexes('tags', table),
    unique('tags_name_unique').on(table.name),
  ],
)

export const opportunityTags = pgTable(
  'opportunity_tags',
  {
    id: getId(),
    opportunityId: getIdReference(() => opportunities.id),
    tagId: getIdReference(() => tags.id),
  },
  (table) => [
    index('opportunity_tags_opportunity_id_idx').on(table.opportunityId),
    index('opportunity_tags_tag_id_idx').on(table.tagId),
    unique('opportunity_tags_unique').on(table.opportunityId, table.tagId),
  ],
)

export const tagsRelations = relations(tags, ({ many }) => ({
  opportunityTags: many(opportunityTags),
}))

export const opportunityTagsRelations = relations(
  opportunityTags,
  ({ one }) => ({
    opportunity: one(opportunities, {
      fields: [opportunityTags.opportunityId],
      references: [opportunities.id],
    }),
    tag: one(tags, {
      fields: [opportunityTags.tagId],
      references: [tags.id],
    }),
  }),
)
